// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { MantineTheme, Text } from '@mantine/core';
import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ProcedureReportProps } from '../../../../Types/LogT';
import { WorkflowS } from '../../../../Service/WorkflowS';
import { getReportExecutionState } from './reportExecutionState';

const CreateQuestionnaireReport: FC<ProcedureReportProps> = ({ report }) => {
  const { entityId, executionStatus } = report ?? {};
  const { id: eventId } = useParams();
  const navigate = useNavigate();
  const executionState = getReportExecutionState(executionStatus);
  const questionnaireCreated = executionState === 'COMPLETED';
  const questionnaireColor = (theme: MantineTheme) =>
    questionnaireCreated ? (theme.colorScheme === 'dark' ? theme.colors.blue[1] : theme.colors.blue[4]) : 'inherit';

  const onClick = () => {
    if (eventId && questionnaireCreated) {
      navigate(`/events/${eventId}/questionnaires/${entityId}`);
    }
  };

  return (
    <Text>
      {executionState === 'SKIPPED' ? 'Erstellung des ' : ''}
      <Text
        span
        weight="bolder"
        onClick={onClick}
        variant={questionnaireCreated ? 'link' : 'text'}
        color={questionnaireCreated ? 'blue' : 'inherit'}
        sx={(theme) => ({
          cursor: questionnaireCreated ? 'pointer' : 'default',
          color: questionnaireColor(theme),
        })}
      >
        Fragebogen
      </Text>{' '}
      {executionState === 'COMPLETED' && 'wurde erstellt.'}
      {executionState === 'PLANNED' && 'wird erstellt.'}
      {executionState === 'SKIPPED' && 'wurde übersprungen.'}
      {executionState === 'NOT_EXECUTED' && 'wurde nicht erstellt.'}
      {WorkflowS.getWorkflowErrorDescription(report)}
    </Text>
  );
};

export default CreateQuestionnaireReport;
